const { transferStatus } = require('@transfeeradev/api-enums');
const { logger } = require('@transfeeradev/logger');
const ErrorMessageFinder = require('./ErrorMessageFinder');

class TransferErrorService {
  static display(status, { code = null, message = null } = {}) {
    if (!code && message) {
      code = this.#findErrorCodeByMessage(message);
    }

    if (this.#shouldNotDisplay(status, { code, message })) {
      return null;
    }
    return {
      code,
      message
    };
  }

  static #findErrorCodeByMessage(message) {
    const foundError = ErrorMessageFinder.findByMessage(message);
    if (foundError?.code) {
      logger.warn(
        { foundError: foundError.code, receivedMessage: message },
        `Error code exists but is not being received`
      );

      return foundError.code;
    }
    return null;
  }

  static #shouldNotDisplay(status, { code = null, message = null } = {}) {
    const TRANSFER_CANCELLED_REQUESTED_BY_CUSTOMER_DESCRIPTION = 'Cancelamento solicitado pelo cliente';

    return (
      status === transferStatus.FAILED_INTERNAL ||
      (!code && !message) ||
      message?.includes(TRANSFER_CANCELLED_REQUESTED_BY_CUSTOMER_DESCRIPTION)
    );
  }
}

module.exports = TransferErrorService;
